import { scrollAnime } from "./components/scrollAnime";
import { humbergerMenuButton } from "./components/humbergerMenuButton";
import { accordion } from "./components/accordion";
import { tab } from "./components/tab";
import { inputError } from "./components/inputError";
import { inputImage } from "./components/inputImage";
import { sliderFooter } from "./components/slider-footer";
import { slider } from "./components/slider";
import { slider2 } from "./components/slider2";
import { megaMenu } from "./components/megaMenu";
import { menuToggle } from "./components/menuToggle";
import { pageTop } from "./components/pageTop";
import { fontSizeChange } from "./components/fontSizeChange";



$(document).ready(function () {

  (() => {
    /*
    アニメーション用関数
    */
    //アニメーション用クラスを定義
    const animeEl = ".p-top--anim";
    //スクロール時に付与されるクラス定義
    const addAnimeClass = "animation";
    scrollAnime(animeEl, addAnimeClass);

  })();

  (() => {
    /*
    ハンバーガーメニュー用関数
    */
    //ハンバーガーメニューボタンクラス定義
    const buttonEl = "#humberge-button";
    //ハンバーガーメニュークラス定義
    const menuEl = "#humberge-menu";
    //ハンバーガーメニュー閉じるボタン定義
    const closeEl = "#humberge-button-close";
    humbergerMenuButton(buttonEl, menuEl, closeEl);
  })();

  (() => {
    /*
    スライダー用関数
    */
    const sliderEl = ".swiper-top";
    slider(sliderEl);
  })();

  (() => {
    /*
    スライダー用関数
    */
    const sliderFooterEl = ".swiper-footer";
    sliderFooter(sliderFooterEl);
  })();

  (() => {
    /*
    スライダー用関数
    */
    const slider2El = ".swiper-citizen";
    slider2(slider2El);
  })();

  (() => {
    /*
    アコーディオン用関数
    */
    //アコーディオンラッパークラス定義
    const accordionEl = ".accordion";
    //アコーディオンボタンクラス定義
    const accordionButtonEl = ".accordionButton";
    //アコーディオンアイテムクラス定義
    const accordionItemEl = ".accordionItem";
    accordion(accordionEl, accordionButtonEl, accordionItemEl);
  })();

  (() => {
    /*
    タブ用関数
    */
    const tabButtonEl = ".p-tab__list__switch";
    const tabListEl = ".p-tab__list";
    const tabContentsEl = ".p-tab__content";
    const tabWrap = ".p-tab";
    tab(tabButtonEl, tabListEl, tabContentsEl, tabWrap);
  })();

  (() => {
    /*
    メガメニュー用関数
    */
    //メガメニューラッパークラス定義
    const megaMenuEl = "#megaMenu";
    //メガメニューナビアイテムクラス定義
    const megaMenuItemEl = ".megaMenuItem";
    //メガメニューコンテンツクラス定義
    const megaMenuContents = ".megaMenuContents";
    megaMenu(megaMenuEl, megaMenuItemEl, megaMenuContents);
  })();

  (() => {
    /*
    gnaviメニュー内トグルメニュー
    */
    //メガメニューラッパークラス定義
    const menuToggleEl = ".l-gnavi__menu__list";
    //メガメニューナビアイテムクラス定義
    const menuToggleButtonEl = ".l-gnavi__menu__button";
    //メガメニューコンテンツクラス定義
    menuToggle(menuToggleEl, menuToggleButtonEl);
  })();

  (() => {
    /*
    フォームバリデーション用関数
    */
    //フォームラッパークラス定義
    const formEl = ".p-form";
    //エラー表示用クラス定義
    const addErrorClass = "c-error";
    //WPなどでフォームから出力されるエラークラスを定義
    const errorEl = "error";
    inputError(formEl, addErrorClass, errorEl);
  })();

  (() => {
    /*
    フォーム画像入力欄用関数
    */
    const inputImageEl = ".c-input--image";
    const inputDelEl = ".c-input--image__del";
    const inputUplinkEl = ".c-input--image__up-link";
    inputImage(inputImageEl, inputDelEl, inputUplinkEl);
  })();

  (() => {
    /*
    ページトップボタン用関数
    */
    //ボタンクラス定義
    const pageTopButtonEl = "#pageTop";
    //初期状態を定義
    const hide = true;
    pageTop(pageTopButtonEl, hide);
  })();

  (() => {
    /*
    フォントサイズ変更ボタン用関数
    */
    //ボタンクラス定義
    const fontChangeEl = ".fontSizeChange";
    //フォントサイズ大ボタン定義
    const fontBigEl = ".fontSizeBig";
    //フォントサイズ通常ボタン定義
    const fontNormalEl = ".fontSizeNormal";
    fontSizeChange(fontChangeEl, fontBigEl, fontNormalEl);
  })();

});

